import apiClient from './client';
import type { User } from '../types';

// Get current user profile
export async function getCurrentUser(): Promise<User> {
  const response = await apiClient.get<User>('/user/me');
  return response.data;
}

// Update user profile
export interface UpdateProfileRequest {
  name?: string;
  language?: string;
  timezone?: string;
}

export async function updateProfile(data: UpdateProfileRequest): Promise<User> {
  const response = await apiClient.put<User>('/user/me', data);
  return response.data;
}

// Change password
export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export async function changePassword(data: ChangePasswordRequest): Promise<{ message: string }> {
  const response = await apiClient.post<{ message: string }>('/user/change-password', data);
  return response.data;
}

// Delete account
export interface DeleteAccountRequest {
  password: string;
}

export async function deleteAccount(data: DeleteAccountRequest): Promise<{ message: string }> {
  const response = await apiClient.delete<{ message: string }>('/user/me', { data });
  return response.data;
}

// Referral stats
export interface Referral {
  id: string;
  referrer_id: string;
  referee_id: string;
  status: 'pending' | 'completed';
  reward_amount: number;
  created_at: string;
  completed_at?: string;
}

export interface ReferralStats {
  invitation_code: string;
  total_invited: number;
  total_earned: number;
  referrals: Referral[];
}

export async function getReferralStats(): Promise<ReferralStats> {
  const response = await apiClient.get<ReferralStats>('/user/referrals');
  return response.data;
}
